module.exports = __webpack_public_path__ + "img/04-register.319150de.png";